import { Route, Routes, useLocation } from 'react-router-dom';
import InvoiceArea from '@/components/invoiceArea/InvoiceArea';
import InvoiceHistory from './components/history/InvoiceHistory';
import { useEffect, useState } from 'react';
import { Preview } from './components/preview/Preview';
import { Customers } from './components/customers/Customers';
import { Transactions } from './components/transactions/Transactions';
import { $customers, $invoices, $transactions } from './stores';
import { customersRepository } from './database/repositories/customersRepository';
import { transactionsRepository } from './database/repositories/transactionsRepository';
import { invoicesRepository } from './database/repositories/invoicesRepository';
import { SharedInvoice } from './components/sharedInvoice/SharedInvoice';
import { Menu } from './shared/menu/Menu';
import { useNetworkStatus } from './hooks/networkStatus';
import { CustomersArchive } from './components/archive/customersArchive/customersArchive';
import { InvoicesArchive } from './components/archive/invoicesArchive/invoicesArchive';
import { Settings } from './components/settings/Settings';
import './App.scss';
import { useDb } from './database/provider/useDb';
import { migrateToLatest } from './utils';
import journal from "../drizzle/meta/_journal.json";
import packageJson from '../package.json';

type Props = {
  updateAvailable: boolean
}

function App({ updateAvailable }: Props) {
  const location = useLocation();
  const isOnline = useNetworkStatus();
  const db = useDb();
  const [isArchiveOpen, setArchiveOpen] = useState<boolean>(false);
  const [isUpdateAvailable, setIsUpdateAvailable] = useState(updateAvailable);

  async function handleMigrate() {
    try { 
      await migrateToLatest(db, journal);
      setIsUpdateAvailable(false);
      window.location.reload();
      localStorage.setItem("version", packageJson.version);
    }
    catch (err: any) {
      throw new Error(err.message)
    }
  }
  useEffect(() => {
    try {
      (async () => {
        if (!$customers.value.isLoad) {
          const allCustomers = await customersRepository.getAllWithContacts(db);
          $customers.set({ isLoad: true, values: allCustomers });
        }

        if (!$transactions.value.isLoad) {
          const allTransactions = await transactionsRepository.getAll(db);
          $transactions.set({ isLoad: true, values: allTransactions });
        }

        if (!$invoices.value.isLoad) {
          const allInvoices = await invoicesRepository.getAllUnArchived(db);
          $invoices.set({ isLoad: true, values: allInvoices });
        }
        if (location.pathname.split("/")[1] === "archive") setArchiveOpen(true);
      })();
    }
    catch (err: any) {
      throw new Error(err.message);
    }

  }, [db]);

  return (
    <div className="container">
      <Routes>
        <Route path="/" element={<Menu updateAvailable={isUpdateAvailable} isArchiveOpen={isArchiveOpen} isOnline={isOnline} handleMigrate={handleMigrate} setArchiveOpen={setArchiveOpen}>
          <InvoiceArea />
        </Menu>} />
        <Route path="/history" element={<Menu updateAvailable={isUpdateAvailable} isArchiveOpen={isArchiveOpen} isOnline={isOnline} handleMigrate={handleMigrate} setArchiveOpen={setArchiveOpen}>
          <InvoiceHistory />
        </Menu>} />
        <Route path="/preview" element={<Menu updateAvailable={isUpdateAvailable} isArchiveOpen={isArchiveOpen} isOnline={isOnline} handleMigrate={handleMigrate} setArchiveOpen={setArchiveOpen}>
          <Preview />
        </Menu>} />
        <Route path="/transactions" element={<Menu updateAvailable={isUpdateAvailable} isArchiveOpen={isArchiveOpen} isOnline={isOnline} handleMigrate={handleMigrate} setArchiveOpen={setArchiveOpen}>
          <Transactions />
        </Menu>} />
        <Route path="/customers" element={<Menu updateAvailable={isUpdateAvailable} isArchiveOpen={isArchiveOpen} isOnline={isOnline} handleMigrate={handleMigrate} setArchiveOpen={setArchiveOpen}>
          <Customers />
        </Menu>} />
        <Route path="/archive/customers" element={<Menu updateAvailable={isUpdateAvailable} isArchiveOpen={isArchiveOpen} isOnline={isOnline} handleMigrate={handleMigrate} setArchiveOpen={setArchiveOpen}>
          <CustomersArchive />
        </Menu>} />
        <Route path="/archive/invoices" element={<Menu updateAvailable={isUpdateAvailable} isArchiveOpen={isArchiveOpen} isOnline={isOnline} handleMigrate={handleMigrate} setArchiveOpen={setArchiveOpen}>
          <InvoicesArchive />
        </Menu>} />
        <Route path="/settings" element={<Menu updateAvailable={isUpdateAvailable} isArchiveOpen={isArchiveOpen} isOnline={isOnline} handleMigrate={handleMigrate} setArchiveOpen={setArchiveOpen}>
          <Settings />
        </Menu>} />
        <Route path="/invoice/:token" element={<SharedInvoice />} />
        <Route path="*" element={<>not found</>} />
      </Routes>
    </div>
  )
}

export default App;
